<template>
  <div>
    <m-icon-button
      icon="search"
      v-on:click="clickOnSearchButton()"
      v-if="!isInputShown"
    />
    <m-text-field
      v-if="isInputShown"
      v-model="searchText"
      id="textfield-search-full"
      aria-label="Texto busqueda simple"
      outlined
      class="app-text-field--search-full"
      v-on:keyup.native.enter="clickOnSearchButton()"
      v-on:keyup.native.esc="hideInput"
      :focused="isInputSearchFocused"
    >
      <m-text-field-icon
        icon="search"
        slot="trailingIcon"
        v-on:click="clickOnSearchButton()"
      />
    </m-text-field>
  </div>
</template>

<script>
export default {
  name: "app-search-full",
  props: {
    mdPlaceholder: { type: String }
  },
  data() {
    return {
      isInputShown: false,
      isInputSearchFocused: false,
      searchText: ""
    };
  },
  methods: {
    clickOnSearchButton() {
      if (!this.searchText) {
        this.isInputShown = !this.isInputShown;
        this.isInputSearchFocused = true;

        // this.$nextTick(() => {
        //   this.$refs["inputSearch"].$el.focus();
        // });
      } else {
        this.emitSearchEvent();
        this.isInputShown = false;
        this.searchText = "";
      }
    },
    emitSearchEvent() {
      this.$emit("searchFullSubmitted", this.searchText);
    },
    hideInput() {
      this.searchText = "";
      this.isInputShown = false;
    }
  }
};
</script>

<style lang="scss">
.mdc-text-field.app-text-field--search-full {
  width: 100%;
  height: 40px;

  input.mdc-text-field__input {
    width: 22em;
    font-size: 1em;
    height: 40px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 3px;
  }

  .mdc-notched-outline {
    height: 40px;
    // box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    //   0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  }

  .mdc-text-field__icon {
    bottom: 8px;
  }
}
</style>
